/**
 * =============================================================================
 * RESOURCES NAVIGATION COMPONENT (IFRAME VERSION)
 * =============================================================================
 * 
 * Minimal white header bar for embedded iframe use.
 * Empty bar that sits below the host site's navigation.
 * 
 * =============================================================================
 */

import React from 'react';
import './ResourcesNav.css';

const ResourcesNav = () => {
  return (
    <div className="resources-navbar-wrapper" />
  );
};

export default ResourcesNav;